module.exports = __webpack_public_path__ + "img/Organise Team.3b372f31.png";